/* global axios */
import ApiClient from './ApiClient';

class CommercialDashboardAPI extends ApiClient {
  constructor() {
    super('commercial_dashboard', { accountScoped: true });
  }

  overview(params = {}) {
    return axios.get(`${this.url}/overview`, { params });
  }

  funnel(params = {}) {
    return axios.get(`${this.url}/funnel`, { params });
  }
}

export default new CommercialDashboardAPI();
